import React from 'react';
export function Footer() {
  return <footer className="bg-[#0f2417] text-[#c9d4c9] py-12 border-t-4 border-[#6f4e2e]" data-id="element-101">
      <div className="container mx-auto px-4 text-center max-w-2xl" data-id="element-102">
        <h4 className="text-[#f5efe1] font-black text-xl mb-4 font-[Merriweather,_serif]" data-id="element-103">
          🌿 MEGAPACK GESTIÓN AMBIENTAL LISTO™
        </h4>

        <p className="text-[#d8d0bd] mb-6" data-id="element-104">
          Hecho por especialistas, para docentes de Gestión Ambiental de toda
          Argentina.
        </p>

        <div className="flex flex-wrap justify-center gap-4 text-sm mb-8" data-id="element-105">
          <a href="mailto:packcentral23@gmail.com" className="hover:text-[#e7c766] transition-colors" data-id="element-106">
            📧 packcentral23@gmail.com
          </a>
          <span className="hidden sm:inline text-[#6f4e2e]" data-id="element-107">·</span>
          <span className="hover:text-[#e7c766] transition-colors" data-id="element-108">
            📱 @centralpack.ar
          </span>
        </div>

        <div className="text-xs text-[#7f8c7f] border-t border-[#2f6b47]/40 pt-8 space-y-3" data-id="element-109">
          <p data-id="element-110">
            © MEGAPACK GESTIÓN AMBIENTAL LISTO™ 2026 — Todos los derechos
            reservados.
          </p>
          <p className="italic text-[#a9b8ab]" data-id="element-111">
            🌿🇦🇷 "La próxima clase que des, podés entrar al aula con
            conocimiento ambiental completo, ejemplos argentinos reales, la Ley
            27.621 incorporada en tu planificación y material listo para usar.
            El sistema está preparado. Solo falta que lo descargues."
          </p>
        </div>
      </div>
    </footer>;
}